// extracted by mini-css-extract-plugin
module.exports = {"icon":"HelpLink_icon_3kIU3"};